import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import LegalContent from '../../LegalModal/Content';

import * as Layout from '../styled';
import * as Styled from './styled';

import { BackNavigate } from '../Components/BackNavigate';

const LegalTerms = ({ active, onNext }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const onSubmitHandle = () => {
    if (typeof onNext !== "function") return;
    setLoading(true);
    setTimeout(() => {
      onNext?.();
      setLoading(false);
    }, 350);
  }

  let pathSegment = location.pathname.replace(/^\/|\/$/g, "").toLowerCase();


  const routeToSectionMap = {
    "terms-of-use": "terms_of_use",
    "privacy-policy": "privacy_policy",
    "waiver": "waiver",
    "disclaimer": "disclaimer",
  };

  const defaultSection = routeToSectionMap[pathSegment] || "terms_of_use";

  if (!active)
    return null;

  return (
    <Layout.Screen $terms>
      <BackNavigate to={`/`} alternative />

      <Styled.LegalWrapper>
        <LegalContent
          readOnly={typeof onNext !== "function"}
          loading={loading}
          onSubmit={onSubmitHandle}
          defaultSection={defaultSection}
        />
      </Styled.LegalWrapper>
    </Layout.Screen>
  );
}

export default LegalTerms;
